import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdMobileAppLinkingConfigsId = "/companies/:company_id/mobile_app_linking_configs/:id";

export const deleteCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/mobile_app_linking_configs",
  "/companies/:company_id/mobile_app_linking_configs/:id",
];
